"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTemplateToWorkbook = void 0;
const exceljs_1 = require("exceljs");
function applyTemplateToWorkbook(workbook, variables, options = {}) {
    const unknownVariables = [];
    workbook.eachSheet((workSheet) => {
        workSheet.eachRow((row) => {
            row.eachCell((cell) => {
                if (`${cell.row}` === "1" && cell.value === "ausblenden") {
                    workSheet.getColumn(cell.col).hidden = true;
                }
                if (cell.note) {
                    cell.note = {};
                }
                if (cell.type === exceljs_1.ValueType.String) {
                    const { newValue, didMatch } = applyTemplateVariables(cell.text, variables, (variableName) => {
                        unknownVariables.push({
                            variableName,
                            cell: cell.address,
                            workSheet: workSheet.name,
                        });
                        if (options.highlightUnknownVariables) {
                            cell.style = {
                                ...cell.style,
                                fill: {
                                    type: "pattern",
                                    pattern: "solid",
                                    fgColor: { argb: "FFFF0000" },
                                },
                            };
                        }
                        if (options.hideUnknownVariables) {
                            return "";
                        }
                        else {
                            return `{${variableName}}`;
                        }
                    });
                    if (didMatch) {
                        const cellBelow = workSheet.getCell(row.number + 1, cell.col);
                        cell.alignment = {
                            ...cell.alignment,
                            wrapText: cell.isMergedTo(cellBelow) || cellBelow.isMergedTo(cell),
                        };
                        if (/^\d+(\.\d+)?$/.test(newValue.trim())) {
                            cell.value = parseFloat(newValue);
                        }
                        else if (newValue.trim() === "true" ||
                            newValue.trim() === "false") {
                            cell.value = newValue.trim() === "true" ? 1 : 0;
                        }
                        else {
                            cell.value = newValue;
                        }
                    }
                }
                else {
                    cell.model.result = undefined;
                }
            });
        });
    });
    workbook.calcProperties.fullCalcOnLoad = true;
    return { unknownVariables };
}
exports.applyTemplateToWorkbook = applyTemplateToWorkbook;
function applyTemplateVariables(template, variables, handleUnknownVariable) {
    let didMatch = false;
    const newValue = template.replace(/\{([^}]+)\}/g, (match) => {
        didMatch = true;
        const variableName = match.slice(1, -1).trim();
        const value = get(variables, variableName);
        if (value != null) {
            return value;
        }
        else {
            return handleUnknownVariable(variableName);
        }
    });
    return { newValue, didMatch };
}
function get(obj, path) {
    let current = obj;
    const parts = path.split(".");
    for (let part of parts) {
        if (current == null) {
            return null;
        }
        current = current[part];
    }
    return current == null ? null : `${current}`;
}
//# sourceMappingURL=templateEngine.js.map